import React, { FC } from 'react'

import { Image } from '../Image'

import incomingEnvelope from './images/incoming-envelope.png'
import manShrugging from './images/man-shrugging.png'
import redHeart from './images/red-heart.png'
import rocket from './images/rocket.png'
import snowCappedMountain from './images/snow-capped-mountain.png'
import spiralCalendar from './images/spiral-calendar.png'
import tearOffCalendar from './images/tear-off-calendar.png'
import wavingHand from './images/waving-hand.png'

const EMOJI_IMAGE_MAPPING = {
  'incoming-envelope': incomingEnvelope,
  'man-shrugging': manShrugging,
  'red-heart': redHeart,
  'snow-capped-mountain': snowCappedMountain,
  'spiral-calendar': spiralCalendar,
  'tear-off-calendar': tearOffCalendar,
  'waving-hand': wavingHand,
  rocket: rocket,
} as const

export const EmojiIcon: FC<{
  size?: number
  name: keyof typeof EMOJI_IMAGE_MAPPING
}> = ({ size = 5, name }) => {
  return <Image size={size} source={EMOJI_IMAGE_MAPPING[name]} />
}
